import React from 'react'
import Accounts from 'src/app/Accounts/Accounts'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import AccountBudgetHistoryAppRoute from 'src/navigation/appRoutes/account/accountBudgetHistory.appRoute'
import AccountBudgetsAppRoute from 'src/navigation/appRoutes/account/accountBudgets.appRoute'
import AccountOverviewAppRoute from 'src/navigation/appRoutes/account/accountOverview.appRoute'
import AccountSettingsAppRoute from 'src/navigation/appRoutes/account/accountSettings.appRoute'
import AccountTransactionsAppRoute from 'src/navigation/appRoutes/account/accountTransactions.appRoute'
import AccountVirtualCardsAppRoute from 'src/navigation/appRoutes/account/accountVirtualCards.appRoute'
import AccountsAccountsAppRoute from 'src/navigation/appRoutes/accounts/accountsAccounts.appRoute'
import AccountsBudgetsAppRoute from 'src/navigation/appRoutes/accounts/accountsBudgets.appRoute'
import AccountsRequestsAppRoute from 'src/navigation/appRoutes/accounts/accountsRequests.appRoute'
import AccountsVirtualCardsAppRoute from 'src/navigation/appRoutes/accounts/accountsVirtualCards.appRoute'
import { accountsRouteProps } from 'src/navigation/routeProps'

const AccountsAppRoute: AppRoute = {
  routeProps: accountsRouteProps,
  component: <Accounts />,
  subRoutes: [
    AccountsAccountsAppRoute,
    AccountsBudgetsAppRoute,
    AccountsVirtualCardsAppRoute,
    AccountsRequestsAppRoute,
    AccountBudgetHistoryAppRoute,
  ],
  exceptions: [
    AccountTransactionsAppRoute,
    AccountOverviewAppRoute,
    AccountBudgetsAppRoute,
    AccountVirtualCardsAppRoute,
    AccountSettingsAppRoute,
    AccountBudgetHistoryAppRoute,
  ],
  meta: { contentType: SidenavContentType.Main },
}

export default AccountsAppRoute
